// AUTO-GENERATED SQL Builder (V40 Final) for ServiceCategory
import { 
  SqlField, 
  SqlExp, 
  SqlExpChain, 
  SqlFn, 
  SqlLiteral, 
  SqlSubQuery, 
  SqlApplyColumn, 
  SqlNavHybrid, 
  createNavHybrid 
} from '../utils/sql-core';
import { SqlAst } from '../utils/sql-ast';

export class ServiceCategorySql {
  private ast = new SqlAst('ServiceCategory', 'serviceCategory');
  public readonly main: any = {};

  public guid: SqlField;
  public code: SqlField;
  public label: SqlField;
  public color: SqlField;
  public sortOrder: SqlField;
  public createdByUser: SqlNavHybrid;
  public updatedByUser: SqlNavHybrid;
  public bookingPackageList: SqlNavHybrid;
  public bookingSlotSelectionList: SqlNavHybrid;
  public checklistItemList: SqlNavHybrid;
  public offeringList: SqlNavHybrid;
  public offeringSlotList: SqlNavHybrid;
  public vendorList: SqlNavHybrid;
  public id: SqlField;
  public isDeleted: SqlField;
  public createdBy: SqlField;
  public createdDate: SqlField;
  public updatedBy: SqlField;
  public updatedDate: SqlField;

  constructor() {
    this.guid = new SqlField('serviceCategory', 'guid', '', 'id', 'serviceCategory_guid');
    this.code = new SqlField('serviceCategory', 'code', '', 'id', 'serviceCategory_code');
    this.label = new SqlField('serviceCategory', 'label', '', 'id', 'serviceCategory_label');
    this.color = new SqlField('serviceCategory', 'color', '', 'id', 'serviceCategory_color');
    this.sortOrder = new SqlField('serviceCategory', 'sortOrder', '', 'id', 'serviceCategory_sortOrder');
    this.createdByUser = createNavHybrid('serviceCategory', 'serviceCategory_createdByUser', 'User');
    this.updatedByUser = createNavHybrid('serviceCategory', 'serviceCategory_updatedByUser', 'User');
    this.bookingPackageList = createNavHybrid('serviceCategory', 'serviceCategory_bookingPackageList', 'BookingPackage');
    this.bookingSlotSelectionList = createNavHybrid('serviceCategory', 'serviceCategory_bookingSlotSelectionList', 'BookingSlotSelection');
    this.checklistItemList = createNavHybrid('serviceCategory', 'serviceCategory_checklistItemList', 'ChecklistItem');
    this.offeringList = createNavHybrid('serviceCategory', 'serviceCategory_offeringList', 'Offering');
    this.offeringSlotList = createNavHybrid('serviceCategory', 'serviceCategory_offeringSlotList', 'OfferingSlot');
    this.vendorList = createNavHybrid('serviceCategory', 'serviceCategory_vendorList', 'Vendor');
    this.id = new SqlField('serviceCategory', 'id', '', 'id', 'serviceCategory_id');
    this.isDeleted = new SqlField('serviceCategory', 'isDeleted', '', 'id', 'serviceCategory_isDeleted');
    this.createdBy = new SqlField('serviceCategory', 'createdBy', '', 'id', 'serviceCategory_createdBy');
    this.createdDate = new SqlField('serviceCategory', 'createdDate', '', 'id', 'serviceCategory_createdDate');
    this.updatedBy = new SqlField('serviceCategory', 'updatedBy', '', 'id', 'serviceCategory_updatedBy');
    this.updatedDate = new SqlField('serviceCategory', 'updatedDate', '', 'id', 'serviceCategory_updatedDate');

    for (const k of Object.keys(this)) {
      const v = (this as any)[k];
      if (v instanceof SqlField) this.main[k] = v;
    }
  }

  // SELECT
  select(fn:(x:ServiceCategorySql)=>any) {
    this.ast.addSelectObject(fn(this));
    return this;
  }

  // WHERE
  where(fn:(x:ServiceCategorySql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  and(fn:(x:ServiceCategorySql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  or(fn:(x:ServiceCategorySql)=>SqlExp | SqlExpChain) {
    this.ast.addOr(fn(this));
    return this;
  }

  // JOIN
  join(fn:(x:ServiceCategorySql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f);
    return this;
  }
  leftJoin(fn:(x:ServiceCategorySql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'LEFT');
    return this;
  }
  rightJoin(fn:(x:ServiceCategorySql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'RIGHT');
    return this;
  }

  // AND JOIN
  andJoin(fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    const last = this.ast.joins[this.ast.joins.length - 1];
    if (!last) throw new Error('andJoin() before join()');

    const left = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(this.ast.alias, prop)
    });
    const right = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(last.alias, prop)
    });

    const exp = (this.ast as any).compileExp(fn(left, right));

    if (typeof last.on === 'string') {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[
          { column:last.on, operator:'', value:null, isTrusted:true, subFilters:[] },
          exp
        ]
      };
    }
    else if (last.on.logic === 'And') {
      last.on.subFilters.push(exp);
    }
    else {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[ last.on, exp ]
      };
    }

    return this;
  }

  // CTE
  with(name:string, fn:(c:any)=>any) {
    this.ast.with(name, fn);
    return this;
  }
  withRecursive(name:string, fn:(c:any)=>any) {
    this.ast.withRecursive(name, fn);
    return this;
  }

  // CTE JOIN
  joinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.joinCTE(name, alias, fn);
    return this;
  }
  fullJoinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.fullJoinCTE(name, alias, fn);
    return this;
  }

  // SUBQUERY
  subQuery(fn:(b:any)=>any) {
    return new SqlSubQuery(fn);
  }

  // APPLY
  apply(name:string, fn:(b:any)=>any) {
    this.ast.apply(name, fn);
    return this;
  }
  applyColumn(name:string, fn:(b:any)=>SqlField) {
    return this.ast.applyColumn(name, fn);
  }
  crossApply(app:any) {
    this.ast.crossApply(app);
    return this;
  }

  // GROUP BY
  groupBy(fn:(x:ServiceCategorySql)=>SqlField[]) {
    this.ast.addGroup(fn(this));
    return this;
  }

  // HAVING
  having(fn:(x:ServiceCategorySql)=>SqlExp | SqlExpChain) {
    this.ast.addHaving(fn(this));
    return this;
  }

  // ORDER
  orderBy(fn:(x:ServiceCategorySql)=>any[]) {
    this.ast.addOrder(fn(this));
    return this;
  }

  // UNION
  union(fn:(q:any)=>any) {
    this.ast.union(fn);
    return this;
  }
  unionAll(fn:(q:any)=>any) {
    this.ast.unionAll(fn);
    return this;
  }

  limit(n:number) { this.ast.take = n; return this; }
  offset(n:number) { this.ast.skip = n; return this; }

  build() {
    return this.ast.toQueryDescriptor();
  }
}
